import { call } from "@saas/api-client";
import { Badge, Card, ErrorAlert, formatDate, Loading, PageHeader, Table, useAsync } from "@saas/ui";
import { api } from "./api";

function statusText(status: string, reason: string | null | undefined): string {
  if (status === "Active") return "Booked";
  return reason === "RoomDeactivated" ? "Cancelled (room deactivated)" : "Cancelled by booker";
}

export function BookingsPage() {
  const bookings = useAsync(() => call(api.GET("/api/bookings")), []);

  return (
    <>
      <PageHeader title="All bookings" description="Every room booking in your organisation, latest first." />
      <Card>
        <ErrorAlert error={bookings.error} />
        {bookings.loading && !bookings.data ? (
          <Loading />
        ) : bookings.data && bookings.data.length === 0 ? (
          <p className="sb-muted">Nobody has booked a room yet.</p>
        ) : (
          <Table caption={`${bookings.data?.length ?? 0} booking(s)`} headers={["Room", "Booked by", "Starts", "Ends", "Status"]}>
            {bookings.data?.map((b) => (
              <tr key={b.id} data-testid={`booking-${b.id}`}>
                <td>{b.roomName}</td>
                <td>{b.bookerEmail}</td>
                <td>{formatDate(b.startsAt)}</td>
                <td>{formatDate(b.endsAt)}</td>
                <td>
                  <Badge tone={b.status === "Active" ? "success" : "neutral"}>{statusText(b.status, b.cancellationReason)}</Badge>
                </td>
              </tr>
            ))}
          </Table>
        )}
      </Card>
    </>
  );
}
